module.exports = require('./helpers/bundle-url').getBundleURL('5I3eL') + "logo-dark.eefe0b7f.svg";